export const STEPS_NEW_PROCESS = [
  'Información básica',
  'Ruta de configuración',
  'Pruebas a aplicar',
  'Perfil ideal y ajustes',
  'Usuarios y cierre',
]

export const STEPS_NEW_PROCESS_360 = [
  'Información básica',
  'Pruebas a aplicar',
  'Configuración 360',
  'Usuarios y cierre',
]

export const BRAIN_QUADRANTS_DOUBLE = [
  {
    value: 'FD',
    label: 'FD',
  },
  {
    value: 'FI',
    label: 'FI',
  },
  {
    value: 'BD',
    label: 'BD',
  },
  {
    value: 'BI',
    label: 'BI',
  },
  {
    value: 'DI',
    label: 'DI',
  },
  {
    value: 'DB',
    label: 'DB',
  },
  {
    value: 'DF',
    label: 'DF',
  },
  {
    value: 'DD',
    label: 'DD',
  },
]

export const BETESA_DEFAULT_CATEGORY_ID = 1
